define.alias("shared/components/shared/wizard/slide/footer", "calendar/components/shared/wizard/slide/footer");